import { Theme } from './symbols';

export const theme: Theme = {
    name: 'lccv',
    properties: {
        '--background': '#001f54',
        '--bg-primary': '#eee',
        '--bg-page': '#fff',
        '--on-background': '#fff',
        '--form-label-text': '#777',

        '--primary': '#eee',
        '--on-primary': '#00000013',
        '--secondary': '#fff',
        '--on-secondary': '#777',
        '--color-primary': '#000',
        '--on-color-primary': '#fff',
        '--color-secondary': '#100e0b',
        '--on-color-secondary': '#fff',

        '--invert': 0,
    },
};

export const lccvTheme: Theme = theme;
